<template>
  <div v-if="hasPermission(permissions.smsMessageList)">
    <content-header>{{ $t("smsMessages") }}</content-header>
    <v-content>
      <BootstrapTable
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalRecords"
        :actions="actions"
        @on-change-query="onChangeQuery"
        @on-create="$router.push({ name: 'smsMessages.create' })"
      >
        <template slot="empty-results">{{ $t("noResultsFound") }}</template>
        <template slot="pagination-info" slot-scope="props">
          <template v-if="props.currentPageRowsLength !== 0"
            >{{ totalRecords }} {{ $t("totalRecords") }}</template
          >
          <template v-else>{{ $t("noResultsFound") }}</template>
        </template>
        <template slot="mcPrice" slot-scope="props">
          {{ props.row.mcPrice.toLocaleString() }}
        </template>
        <template slot="date" slot-scope="props">
          {{ moment(props.row.date).format("YYYY-MM-DD") }}
        </template>
        <template slot="attachment" slot-scope="props">
          <show-attachment
            :attachment="props.row.attachment"
            :title="props.row.attachment"
          />
        </template>
        <template
          slot="controls"
          slot-scope="props"
          v-if="
            hasPermission(permissions.smsMessagesEdit) ||
            hasPermission(permissions.smsMessagesDelete)
          "
        >
          <control-buttons
            :props="props"
            :edit-link="
              hasPermission(permissions.smsMessagesEdit) && 'smsMessages.edit'
            "
            :delete-link="
              hasPermission(permissions.smsMessagesDelete) &&
              'smsMessages/DELETE'
            "
            v-on:successAction="loadData(true)"
          />
          <b-button
            v-if="hasPermission(permissions.smsMessagesPrint)"
            @click="prePrintVoucher(props.row.id)"
            variant="success"
            ><i class="fas fa-print"></i
          ></b-button>
        </template>
      </BootstrapTable>
      <is-loading v-if="isLoading" />
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import { smsMessage } from "@/models/smsMessage";
import IsLoading from "@/components/IsLoading";
import ControlButtons from "@/components/ControlButtons";
import {
  permissions,
  serverParams,
  tableActions,
  tableConfigure,
} from "@/plugins/constants";
import BootstrapTable from "@/components/Table/BootstrapTable";
import ShowAttachment from "@/components/ShowAttachment";

export default {
  name: "SmsMessageList",
  components: {
    ShowAttachment,
    ControlButtons,
    IsLoading,
    "v-content": Content,
    ContentHeader,
    BootstrapTable,
  },
  data() {
    return {
      isLoading: false,
      model: new smsMessage(),
      columns: [],
      rows: [],
      actions: tableActions(this.hasPermission(permissions.smsMessageCreate)),
      totalRecords: 0,
      config: tableConfigure(this.$t("smsMessageList")),
      serverParams: serverParams,
      selectedRows: [],
      permissions: permissions,
    };
  },
  beforeMount() {
    this.columns = this.model.getColumns();
  },
  methods: {
    loadData(reset = false) {
      if (reset) {
        serverParams._start = 0;
        serverParams._end = 10;
        serverParams._sort = "";
        serverParams._order = "";
        serverParams._search = "";
      }
      this.isLoading = true;
      this.$store
        .dispatch('smsMessages/GET_ALL', this.serverParams)
        .then((response) => {
          this.rows = response.data;
          this.totalRecords = parseInt(response.headers["x-total-count"]);
          this.isLoading = false;
        })
        .catch(() => (this.isLoading = false));
    },
    onChangeQuery(queryParams) {
      serverParams._start = (queryParams.page - 1) * queryParams.per_page;
      serverParams._end = queryParams.page * queryParams.per_page;
      serverParams._sort = queryParams.sort[0] ? queryParams.sort[0].name : "";
      serverParams._order = queryParams.sort[0]
        ? queryParams.sort[0].order
        : "";
      serverParams._search = queryParams.global_search ?? "";
      this.loadData();
    },
  },
};
</script>
